// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IPolicyStatusDto
 */
export interface IPolicyStatusDto {
    /**
     * 
     * @type {number}
     * @memberof IPolicyStatusDto
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof IPolicyStatusDto
     */
    policy_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IPolicyStatusDto
     */
    status?: IPolicyStatusDtoStatusEnum;
    /**
     * 
     * @type {Date}
     * @memberof IPolicyStatusDto
     */
    valid_from?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IPolicyStatusDto
     */
    valid_to?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IPolicyStatusDto
     */
    coverage_period_end?: Date;
}

/**
* @export
* @enum {string}
*/
export enum IPolicyStatusDtoStatusEnum {
    ACTIVE = 'ACTIVE',
    CANCELED = 'CANCELED',
    FUTURE = 'FUTURE',
    EXPIRED = 'EXPIRED'
}


/**
 * Check if a given object implements the IPolicyStatusDto interface.
 */
export function instanceOfIPolicyStatusDto(value: object): value is IPolicyStatusDto {
    return true;
}

export function IPolicyStatusDtoFromJSON(json: any): IPolicyStatusDto {
    return IPolicyStatusDtoFromJSONTyped(json, false);
}

export function IPolicyStatusDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPolicyStatusDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'policy_id': json['policy_id'] == null ? undefined : json['policy_id'],
        'status': json['status'] == null ? undefined : json['status'],
        'valid_from': json['valid_from'] == null ? undefined : (new Date(json['valid_from'])),
        'valid_to': json['valid_to'] == null ? undefined : (new Date(json['valid_to'])),
        'coverage_period_end': json['coverage_period_end'] == null ? undefined : (new Date(json['coverage_period_end'])),
    };
}

export function IPolicyStatusDtoToJSON(json: any): IPolicyStatusDto {
    return IPolicyStatusDtoToJSONTyped(json, false);
}

export function IPolicyStatusDtoToJSONTyped(value?: IPolicyStatusDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'policy_id': value['policy_id'],
        'status': value['status'],
        'valid_from': value['valid_from'] == null ? undefined : ((value['valid_from']).toISOString().substring(0,10)),
        'valid_to': value['valid_to'] == null ? undefined : ((value['valid_to']).toISOString().substring(0,10)),
        'coverage_period_end': value['coverage_period_end'] == null ? undefined : ((value['coverage_period_end']).toISOString().substring(0,10)),
    };
}

